export default "__VITE_ASSET__vcavL4RVRMfAVuZyxK23eA__"